import type { FirestoreTimestamp } from "@/lib/types";

/** Convert a Firestore Timestamp wire object to a Date. */
export function tsToDate(ts: FirestoreTimestamp | null | undefined): Date | null {
  if (!ts) return null;
  return new Date(ts._seconds * 1000 + Math.floor(ts._nanoseconds / 1_000_000));
}

const UNITS = ["B", "KB", "MB", "GB", "TB", "PB"] as const;

/** Format a byte count as "1.2 MB". */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
  const exp = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  const value = bytes / Math.pow(1024, exp);
  const unit = UNITS[exp];
  return `${value.toFixed(exp === 0 ? 0 : 1)} ${unit}`;
}
